import { Locale } from "./locale"

export const DEFAULT_CONNECTION_TEXT = {
	en: 'Answer',
	ru: 'Ответ'
} as Record<Locale, string>
